import { Section } from "@/components/ui";
import { FOUNDER } from "@/data/about";

/** Founder's message on a soft blue band, with the founder's photo and the closing line in a highlighter strip. */
export function FounderSection() {
  const { photo } = FOUNDER;
  return (
    <Section tone="brand" labelledBy="about-founder-title" testId="about-founder">
      <div className="relative z-10 grid gap-12 lg:grid-cols-12 lg:items-stretch lg:gap-16">
        <figure
          className="relative mx-auto h-full w-full max-w-xs sm:max-w-sm lg:col-span-5 lg:mx-0 lg:max-w-none"
          data-testid="about-founder-photo"
        >
          <img
            src={`${process.env.PUBLIC_URL}/${photo.file}`}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="h-full min-h-[18rem] w-full rounded-5xl border-2 border-white object-cover object-left-bottom shadow-soft aspect-[3/4] lg:aspect-auto lg:min-h-0"
          />
        </figure>

        <div className="flex flex-col justify-center lg:col-span-7">
          <p className="mb-4 inline-block rounded-full bg-white px-3 py-1 text-xs font-bold uppercase tracking-wider text-ink">
            {FOUNDER.eyebrow}
          </p>
          <h2 id="about-founder-title">
            <span className="block font-heading text-xl font-bold leading-snug text-brand-600 sm:text-3xl">{FOUNDER.lead}</span>
            <span className="mt-2 block font-heading text-4xl font-bold leading-[1.02] sm:text-6xl">{FOUNDER.main}</span>
          </h2>
          <div className="mt-6 space-y-4 text-base text-ink/80 sm:text-lg">
            {FOUNDER.paragraphs.map((text) => (
              <p key={text} className="max-w-[56ch]">
                {text}
              </p>
            ))}
          </div>
          <p className="mt-6 inline-block rounded-2xl bg-sun-300 px-5 py-3 font-heading text-lg font-bold text-ink sm:text-xl">
            {FOUNDER.closing}
          </p>
        </div>
      </div>
    </Section>
  );
}
